// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__dTf11","SearchSection":"Header_SearchSection__VF7BX","UserSection":"Header_UserSection__+cf6r"};